module.exports = __webpack_public_path__ + "img/file-read-11939.3a8ba3e6.png";